/**
 * Builds a link into the customer documentation at `/docs`.
 *
 * IMPORTANT: always render the result with a plain `<a href>`, never with
 * `router-link`. `/docs` is a static nginx location outside the SPA and has no
 * Vue route, so a `router-link` fails the locale constraint, falls through to
 * the router catch-all and redirects the reader to the login page. The failure
 * is client-side only: pasting the same URL loads correctly because nginx
 * serves it directly, so it only appears when someone clicks the link from an
 * already-loaded page. Test these by clicking, not by pasting.
 *
 * The locale comes from the active i18n locale rather than a route param.
 * Dashboard routes live under the unprefixed tree and take their language from
 * the account record, so there is no `:locale` param there to read.
 */
export function docsUrl(locale: string, path = ''): string {
  const lang = locale.toLowerCase().startsWith('de') ? 'de' : 'en'
  const suffix = path.replace(/^\/+/, '')
  return `/docs/${lang}/${suffix}`
}
